var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"rph-header-whatsapp",attrs:{"href":_vm.whatsappPhone,"target":"_blank","rel":"noopener noreferrer","aria-label":"WhatsApp"}},[_c('WhatsApp'),_vm._v(" "),_c('span',[_vm._v("WhatsApp")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }